/**
 * Used to test the staging version of the API Marketplace MFE in production
 * with a subset of power users, by leveraging a feature flag in RACM to switch the MFE's remote entry between the regular production manifest and the staging manifest.
 */
export default {
  remote: 'api_marketplace_mfe_staging_for_prod',
  name: 'apiMarketplace',
  source: 'https://github.com/telus/api-marketplace-mfe',
  urlMapping: {
    localhost: 'http://localhost:4321/mf-manifest.json',
    'simplify.developers.telus.digital':
      'https://assets.wcstage.telus.com/1110683202/api-marketplace-mfe/v1/mf2/mf-manifest.json',
    'simplify.staging.developers.telus.digital':
      'https://assets.wcstage.telus.com/1110683202/api-marketplace-mfe/v1/mf2/mf-manifest.json',
    'simplify.telus.com':
      'https://assets.wcstage.telus.com/1110683202/api-marketplace-mfe/v1/mf2/mf-manifest.json',
  },
};
